import { render, staticRenderFns } from "./VuesticWizard.vue?vue&type=template&id=84a73db8&scoped=true&"
import script from "./VuesticWizard.vue?vue&type=script&lang=js&"
export * from "./VuesticWizard.vue?vue&type=script&lang=js&"
import style0 from "./VuesticWizard.vue?vue&type=style&index=0&id=84a73db8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a73db8",
  null
  
)

component.options.__file = "VuesticWizard.vue"
export default component.exports